import Swiper from 'swiper/bundle';

if ($(".slider-type-1.swiper-container").length > 0) {
    const slider_type_1_swiper = new Swiper(".slider-type-1.swiper-container", {
        slidesPerView: 'auto',
        effect: "cards",
        grabCursor: true,
        navigation: {
            nextEl: ".section-reviews .swiper-button-next.slider-type-1-swiper-button",
            prevEl: ".section-reviews .swiper-button-prev.slider-type-1-swiper-button",
        },
    });
}